import { StoreFormState } from '@navstation-portal/reporting/data-model/vessel-report';
import { signalStoreFeature, type } from '@ngrx/signals';
import { EventCreator, on, withReducer } from '@ngrx/signals/events';

const setCalculationStatus =
  (fieldId: string, status: { loading: boolean; error?: string }) => (state: StoreFormState) => ({
    calculations: { ...state.calculations, [fieldId]: status },
  });

export function withCalculationReducer<TRequest, TSuccess>(
  fieldId: string,
  requested: EventCreator<string, TRequest>,
  success: EventCreator<string, TSuccess>,
  failed: EventCreator<string, Error>
) {
  return signalStoreFeature(
    type<{ state: StoreFormState }>(),
    withReducer(
      on(requested, () => setCalculationStatus(fieldId, { loading: true })),
      on(success, () => setCalculationStatus(fieldId, { loading: false })),
      on(failed, ({ payload }) => setCalculationStatus(fieldId, { loading: false, error: payload.message }))
    )
  );
}
